import { render } from "./TierOneNavItems.vue?vue&type=template&id=89b472de"
import script from "./TierOneNavItems.vue?vue&type=script&lang=js"
export * from "./TierOneNavItems.vue?vue&type=script&lang=js"

import "./TierOneNavItems.vue?vue&type=style&index=0&id=89b472de&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__